import React from 'react';
export function SolutionSection() {
  return <section className="relative bg-garden-dark py-16 px-4 sm:px-6 lg:px-8 text-white text-center overflow-hidden" data-id="element-140">
      {/* Decorative blurred shapes */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-141">
        <div className="absolute top-1/4 -left-32 w-96 h-96 bg-garden-medium rounded-full opacity-20 blur-[100px]" data-id="element-142"></div>
        <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-garden-light rounded-full opacity-20 blur-[100px]" data-id="element-143"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-144">
        <div className="inline-block bg-white/10 backdrop-blur-md border border-white/20 text-white font-bold px-6 py-2 rounded-full mb-6 text-sm tracking-widest uppercase shadow-lg" data-id="element-145">
          ✅ LA SOLUCIÓN
        </div>

        <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tight mb-6 drop-shadow-lg" data-id="element-146">
          EL MANUAL DEL JARDINERO
        </h2>

        <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-12 leading-relaxed max-w-3xl mx-auto font-medium" data-id="element-147">
          Un sistema completo y paso a paso para crear tu huerta en casa y
          mantenerla viva… incluso sin experiencia.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12" data-id="element-148">
          <div className="glass p-8 rounded-3xl transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:bg-white/15 group" data-id="element-149">
            <div className="text-5xl mb-4 transform group-hover:scale-110 transition-transform duration-300" data-id="element-150">
              📂
            </div>
            <p className="text-xl font-bold tracking-wide" data-id="element-151">Abrís el manual</p>
          </div>
          <div className="glass p-8 rounded-3xl transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:bg-white/15 group" data-id="element-152">
            <div className="text-5xl mb-4 transform group-hover:scale-110 transition-transform duration-300" data-id="element-153">
              🌱
            </div>
            <p className="text-xl font-bold tracking-wide" data-id="element-154">Sabés qué plantar</p>
          </div>
          <div className="glass p-8 rounded-3xl transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:bg-white/15 group" data-id="element-155">
            <div className="text-5xl mb-4 transform group-hover:scale-110 transition-transform duration-300" data-id="element-156">
              ✏️
            </div>
            <p className="text-xl font-bold tracking-wide" data-id="element-157">
              Aplicás paso a paso
            </p>
          </div>
        </div>

        <p className="font-serif text-2xl sm:text-3xl font-bold text-earth-light italic" data-id="element-158">
          Sin adivinar. Sin frustrarte. Sin empezar de cero cada vez.
        </p>
      </div>
    </section>;
}